const schema = () => ({
  title: 'Menu dégustation',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'eyebrow',
        'heading',
        'description',
        'price_value',
        'price_unit',
        'price_label',
        'cta_label',
        'cta_href',
        'image',
      ],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Sur-titre',
      type: 'string',
      default: 'Menu dégustation',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'Menu en quatre temps — entrée, plat, fromage ou dessert.',
    },
    description: {
      title: 'Description',
      type: 'string',
      widget: 'textarea',
      default:
        'Une suite composée par le chef autour des arrivages de la semaine. Servi tous les soirs sur réservation, ainsi que le samedi midi.',
    },
    price_value: {
      title: 'Prix',
      type: 'string',
      default: '55',
    },
    price_unit: {
      title: 'Devise',
      type: 'string',
      default: '€',
    },
    price_label: {
      title: 'Libellé prix',
      type: 'string',
      default: 'par personne',
    },
    cta_label: {
      title: 'Texte du bouton',
      description: 'Laisser vide pour masquer le bouton.',
      type: 'string',
      default: 'Voir le menu',
    },
    cta_href: {
      title: 'Lien du bouton',
      description: 'URL de destination du bouton, par exemple /menu.',
      type: 'string',
      default: '/menu',
    },
    image: {
      title: 'Image (optionnelle)',
      type: 'string',
      widget: 'object_browser',
      mode: 'image',
      description:
        'Ajoute une photo à gauche de la carte. Format conseillé : portrait 4:5.',
    },
  },
  required: [],
});

export default schema;
